<template>
  <v-dialog
    v-model="dialog"
    max-width="600px"
    transition="dialog-top-transition"
  >
    <v-card class="forget-password-card pa-5">
      <v-img class="img-header mx-auto" :src="require('@/assets/images/resetpwd/resetpassword.jpg')" />
      <div class="text-header">เปลี่ยนรหัสผ่าน</div>
      <div class="text-password">ใส่อีเมลของคุณเพื่อเปลี่ยนรหัสผ่าน</div>
      <v-form ref="formSignIn">
        <v-text-field
          v-model="signInData.username"
          :rules="[
            Rule.noInPut,
            Rule.noSpace,
            Rule.englishOnly,
            Rule.emailOnly,
          ]"
          placeholder="อีเมล"
          label="ชื่อผู้ใช้(อีเมล)"
          dense
          outlined
          class="px-8"
        ></v-text-field>
      </v-form>
      <v-row class="pa-4">
        <v-col>
          <v-btn color="primary" @click="save" block>ตกลง</v-btn>
        </v-col>
        <v-col>
          <v-btn block color="error" @click="(dialog = false), reset()"
            >ยกเลิก</v-btn
          >
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      signInData: {
        username: ''
      },
      editedIndex: 1,
      NameComponent: 'เปลี่ยนรหัสผ่าน'
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    reset () {
      this.$refs.formSignIn.reset()
    },
    save () {
      if (this.$refs.formSignIn.validate()) {
        if (this.editedIndex > -1) {
          // TODO Update Data
          this.$swal({
            allowEnterKey: false,
            title: `${this.NameComponent}`,
            text: `คุณต้องการ${this.NameComponent}ใช่หรือไม่ ระบบจะทำการส่งฟอร์มไปยังอีเมลที่คุณกรอก`,
            icon: 'info',
            showCancelButton: true,
            cancelButtonText: 'ยกเลิก',
            confirmButtonText: 'ตกลง'
          }).then(async (result) => {
            if (result.isConfirmed) {
              this.$emit('emailUser', this.signInData.username)
            }
          })
        }
      }
    }
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style scoped>
.forget-password-card {
  height: 100%;
  width: 100%;
}
.img-header {
  max-width: 30%;
}
.text-header {
  font-weight: 500;
  font-size: 30px;
  padding-top: 30px;
  text-align: center;
  color: var(--v-primary-base);
}
.text-password {
  padding-top: 20px;
  padding-bottom: 30px;
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
  font-weight: 300;
  font-size: 18px;
}
</style>
